import { Subject } from 'rxjs';

const loaderModalSubject = new Subject();
export const loaderModal = {
    setLoader: (isLoader, backdropOpacity = 0.9) =>
        loaderModalSubject.next({ isLoader: isLoader, backdropOpacity: backdropOpacity }),
    clearLoader: () => loaderModalSubject.next(),
    getLoader: () => loaderModalSubject.asObservable()
};


